import { RECEIPT_STEPS } from "../receipt-steps.service";
import { BaseState } from "./base-state";
import { ExpenseSelectionState } from "./expense-selection-state";
import { StepStateInterface } from "./step-state.interface";

export class TransportDataState extends BaseState implements StepStateInterface {
  ClassConstructor = TransportDataState;
  property = 'transportData';
  slug = RECEIPT_STEPS.transportData;
  lastStep = true;
  async previous(context: any): Promise<StepStateInterface> {
    return new ExpenseSelectionState();
  }

}
